<div class="switcher">
    <span class="toggle">
        @for(label of labels; track label) {
            <span
                class="label"
                [class.active]="currentValue === label.label"
                (click)="onClick(label.label)"
                [matTooltip]="label.tooltip"
            >
                {{ label.label }}
            </span>
        }
    </span>
</div>